import React from "react";
import Button from "@mui/material/Button";
import { Box, Checkbox, FormControlLabel, FormControl, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import MuiDialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import {isEmpty} from "lodash/lang";
import {withTranslation} from "react-i18next";
import { ModalRule } from "@plannel/components/modal/BaseConfigModal";
import { FS } from "@plannel/utils/font-util";

/*
확인/알림 다이얼로그 — 설정 모달(components/modal/BaseConfigModal)과 **다른 부류**다.
문자열 content + onHandler 프로토콜을 쓰는 화면이 138개라 API 는 건드리지 않는다.

겉모습만 BaseConfigModal 과 같은 규격으로 맞춰 두었다(2026-08-26):
  · Paper   : borderRadius 2
  · 제목    : 20 / 700, pl 2 / pb 1
  · 구분선  : 본문 위 + 액션 위 각각 `<ModalRule />` — 셸과 같은 것을 쓴다(좌우 16px 인셋)
  · 액션    : 우측 정렬. 텍스트 Cancel(CloseIcon) + contained OK(DoneAllIcon)
              OK 는 "저장"이 아니라 범용 확인이므로 SaveIcon 이 아니라 DoneAll 이다
              (판단 기준은 saas-web/.claude/skills/config-modal/SKILL.md 의 save/confirm 규약).
폭은 셸과 달리 breakpoint(fullWidth + maxWidth)다 — 호출측이 maxWidth 를 넘겨 쓰고 있다.

ex) checkBox Params
- checkBox = {checkBox: true, checkBoxMessage: "Overwrite? "},
- setChecked = setChecked()
- checked = current checked

*/
const Dialog = (props) => {
  const {open, title, actionName, content, checkBox = {}, setChecked, checked, onHandler, onClose, t, el, cancelText = "cancel", customButton, maxWidth} = props;
  const langTitle = isEmpty(title) ? "" : title === "confirm" ? t("confirmMessage") : t(title);

  /*
   * 예전에는 e.target.name("ok"/"cancel"/"custom")으로 어느 버튼인지 갈랐다.
   * 버튼에 아이콘이 붙으면 아이콘 <span> 이 e.target 이 되어 name 이 사라진다 —
   * 그래서 버튼별로 액션을 직접 넘기는 방식으로 바꿨다. 바깥 계약(onHandler 인자)은 그대로다.
   */
  const hideModal = (action) => {
    let response = false;

    if (action === "ok") {
      response = actionName ? actionName.toUpperCase() : title.toUpperCase();
    } else if (action === "custom") {
      response = "CUSTOM";
    }

    onHandler(response, title.toUpperCase(), el);
    onClose();
  };

  const handleAlgorithmChange = (e) => {
    setChecked(e.target.checked);
  };

  const Linebreak = (msg) => {
    if(isEmpty(msg)) {
      return "";
    }

    return msg.split(/\r\n|\r|\n/)
      .filter(item => !isEmpty(item))
      .map(str => <div key={str}> {str}<br /></div>)
  }

  return (
    <MuiDialog open={open} onClose={() => hideModal("cancel")} fullWidth maxWidth={maxWidth || "xs"}
      PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontSize: FS.DISPLAY, fontWeight: 700, pl: 2, pb: 1 }}>{langTitle}</DialogTitle>
      <ModalRule />
      <DialogContent sx={{ px: 2, py: 2, fontSize: FS.TITLE }}>
        {typeof content === "string" ? Linebreak(content) : content}
        {checkBox.checkBox ?
          <FormControl sx={{ mt: 1, whiteSpace: "pre" }}>
            <FormControlLabel
              control={
                <Checkbox checked={checked} onChange={handleAlgorithmChange} />
              }
              label={checkBox.checkBoxMessage}
            /> </FormControl> : <Box></Box>
        }
      </DialogContent>
      <ModalRule />
      <DialogActions sx={{ px: 2, py: 1.5 }}>
        {
          customButton &&
          React.cloneElement(customButton, { onClick: () => hideModal("custom") })
        }
        <Button size="small" startIcon={<CloseIcon />} sx={{ display: title === "info" ? "none" : "" }}
          onClick={() => hideModal("cancel")}>{t(cancelText)}</Button>
        <Button size="small" variant="contained" disableElevation startIcon={<DoneAllIcon />}
          sx={{ minWidth: 72 }} onClick={() => hideModal("ok")}>{t("ok")}</Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default withTranslation()(Dialog);
